export default __webpack_public_path__ + "1cbaa5ca21857151560335cbfbf971a0.svg";